<template>
    <div class="container card p-5 shadow my-3">
        <h2>{{$t('CREATE_PATIENT')}} </h2>
        <hr>
        
        <b-alert
            :show="dismissCountDown"
            dismissible
            fade
            :variant="response.success === true ? 'success' : 'danger'"
            @dismissed="dismissCountDown = 0"
            >
            {{response.message}}
        </b-alert>

        <div id="form">
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('FIRST_NAME')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.firstName" type="text" class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('LAST_NAME')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.lastName" type="text" class="form-control" >
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('EMAIL')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.email" type="email" class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span class="" id="inputGroup-sizing-lg">{{$t('BIRTHDATE')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input type="date" class="form-control" v-model="patient.birthdate">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span class="" id="inputGroup-sizing-lg">{{$t('SIS')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.sis" type="text" class="form-control">
                </div>
            </div>
           
            <!--<div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('PHONE')}}</span>
        </div>
        <input v-model="patient.phone" type="text" class="form-control" placeholder="Enter Phone">
    </div>
    <div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('MOBILE_PHONE')}}</span>
        </div>
        <input v-model="patient.mobilePhone" type="text" class="form-control" placeholder="Enter Mobile Phone">
    </div>
    <div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('CITY')}}</span>
        </div>
        <input v-model="patient.city" type="text" class="form-control" placeholder="Enter City">
    </div>
    <div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('ADDRESS')}}</span>
        </div>
        <input v-model="patient.address" type="text" class="form-control" :placeholder="$t('ADDRESS')">
    </div>
    <div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('POSTCODE')}}</span>
        </div>
        <input v-model="patient.postcode" type="text" class="form-control" :placeholder="$t('POSTCODE')">
    </div>-->
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('HEIGHT')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.height" type="text" class="form-control">
                </div>
            </div>
             <div class="input-group mb-3">
                <div class="col-12">
                    <span for="inputGroupSelect01">{{$t('LANGUAGE')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <select @change="onLangSelect($event)" class="custom-select" id="inputGroupSelect01">
                        <option v-for="(lang,index) in languages" :selected="defaultLanguage === lang.id" :key="index" :value="lang.id">
                            {{lang.longTitle}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span for="inputGroupSelect01">{{$t('GENDER')}}</span>
                </div>
                <div class="col-5">
                    <select v-model="patient.gender" class="custom-select" id="inputGroupSelect01">
                        <option :value="0"> {{$t('MALE')}} </option>
                        <option :value="1"> {{$t('FEMALE')}} </option>
                    </select>
                </div>
            </div>
            <div class="col-12">
                <button @click="addPatient()" type="button" class="mb-3">{{$t('ADD_PATIENT')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            patient :
            {
                "firstName": "",
                "lastName": "",
                "email": "",
                "sis": "",
                "phone": "",
                "mobilePhone": "",
                "city": "",
                "postcode": "",
                "address": "",
                "countryId": "",
                'gender': 1,
                'height': '',
                'language': ''
            },
            response: {
                success: null,
                message: ""
            },
            countries: [],
            dismissCountDown: 0
        }
    },
    computed: {
        languages: function(){
            var tempLanguages = this.$store.getters.systemLanguages;
            return tempLanguages;
        },
        defaultLanguage() {
            let result = this.$store.getters.systemLanguages.filter(l => l.title.toLowerCase() == 'en')[0].id;
            return result;
        }
    },
    methods: {
        getCountries: function(){
            let self = this;
            this.$http.get("/api/countries/")
                .then(response =>
                {
                    self.countries = response.data;
                    self.patient.countryId = self.countries[0].id;
                })
                .catch();
        },
        addPatient: function(){
            if (!this.patient.languageId) {
                this.patient.languageId = this.defaultLanguage;
            }
            let self = this;
            this.$http.post("/api/patients/add", this.patient)
                .then(response =>
                {
                    self.response = response.data;
                })
                .catch();
        },
        onLangSelect(event) {
            this.patient.languageId = event.target.value;
        }
    },
    created: function () {
        this.getCountries();
    },
    watch: {
        response: function(val){
            this.dismissCountDown = 3;
            if(val.success === true)
            {
                setTimeout(() => {this.$router.push('/patients')}, 1500)
            }
        },
        
    }
}
</script>
<style lang="scss" scoped>
    @import "~vue-datetime/dist/vue-datetime.min.css";
div{
    span.input-group-text {
        width: 200px;
    }
}
</style>
